// Environment helpers (module-level constants)
// Use NEXT_PUBLIC_APP_ENV first (client-exposed), fall back to NODE_ENV for server
export type AppEnv = "production" | "development" | "staging" | "localhost" | string;

export const APP_ENV: AppEnv =
  (process.env.NEXT_PUBLIC_APP_ENV as AppEnv) || (process.env.NODE_ENV as AppEnv) || "development";

export const IS_PRODUCTION = APP_ENV === "production";
export const IS_DEVELOPMENT = APP_ENV === "development";
export const IS_STAGING = APP_ENV === "staging";
export const IS_LOCALHOST = APP_ENV === "localhost";

// Sentry is only enabled in production
export const IS_SENTRY_ENABLED = IS_PRODUCTION;
